module.exports = {"sortorder":{"labels":{"sortOrder":"Ordre de tri","sortOrderInfo":"<strong>Tri:</strong> Plus petit en premier, ensuite par nom.<br><strong>Suggestion:</strong>multiples de 100, plus facile à intercaller des items par la suite.<br><strong>Tri identique:</strong> le bris d'égalité se fera sur le nom.<br><strong>Laisser le tri par défaut à 1000 à moins de vouloir déplacer l'item</strong>"}}}


//////////////////
// WEBPACK FOOTER
// ./components/Custom/SortOrder/sortorder-fr.json
// module id = MMIx
// module chunks = 18